/**
 * JobStatusBadge Component
 * Job-specific status badge with emojis and colors
 * Different from common Badge - this has job status logic built-in
 */

import React from 'react';
import { Badge } from '../common';
import { JobStatus } from '../../types';
import { JOB_STATUS_EMOJIS } from '../../services/jobTypes';

interface JobStatusBadgeProps {
  status: JobStatus;
  size?: 'sm' | 'md' | 'lg';
}

export const JobStatusBadge: React.FC<JobStatusBadgeProps> = ({
  status,
  size = 'md',
}) => {
  const getVariant = () => {
    switch (status) {
      case JobStatus.COMPLETED:
        return 'success';
      case JobStatus.FAILED:
        return 'error';
      case JobStatus.PROCESSING:
        return 'info';
      case JobStatus.PENDING:
        return 'warning';
      default:
        return 'neutral';
    }
  };

  return (
    <Badge variant={getVariant()} size={size} icon={JOB_STATUS_EMOJIS[status]}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>
  );
};